import { useState } from "react";
import logger from "@utils/logger";
import { apiRequest } from "@services/apiClient";

export const useEmailTemplates = () => {
  const [isLoading, setIsLoading] = useState(false);
  const sendEmailTemplates = async (formData) => {
    setIsLoading(true);
    try {
      const payload = {
        patient_id: formData.patient_id,
        patient_name: formData.patient_name,
        template_id: formData.template_id,
        appointment_date: formData.date,
        appointment_time: formData.time,
        clinic_name: formData.clinic,
        form_name:formData.formName,
      };

      const data = await apiRequest({
        method: "POST",
        endpoint: "/emails/send-email-templates",
        body: payload,
      });

      logger.info("Email templates sent successfully");
      return { success: true, data };
    } catch (error) {
      logger.error(`Error in sendEmailTemplates: ${error.message}`);
      return { success: false, error };
    } finally {
      setIsLoading(false);
      logger.debug("Email templates request completed");
    }
  };

  return { sendEmailTemplates, isLoading };
};
